import * as local from '../config/env.local.json';
import { debug } from './logger';
import constants from '../util/constants';

export class AppConfig {
    tag: string;
    appType: string;
    iovationLib: string;
    bioCatchLib: string;
    getBrowserDataLib: string;
    fraudInteractionEndpoint: string;
    manifest: string;
    appConfig?: string;
    cf?: string;
    shellConfig: any;
    identityAppConfig: any;
    authenticationRequired: boolean;
    abandonFormNotification: boolean;
    sessionTimeoutNotification: boolean;
    sessionTimeoutNotificationMsg: string;
    cookieDisabledNotification: boolean;
    cookieDisabledNotificationMsg: string;
    maintenanceMode: boolean;
    maintenanceModeTitle: string;
    maintenanceModeMsg: string;
    maintenanceModeButtonLabel: string;
    maintenanceModeButtonLink: string;
    errorPageTitle: string;
    errorPageMsg: string;
    keepAlive: {
        idleTime: number
    };
    disableKeepAlive: boolean;
    hostName: string;
    clearTokenInit: boolean;

    constructor(config: any) {
        //parsing incoming configuration
        config.shellConfig = JSON.parse(config.shellConfig);
        config.identityAppConfig = JSON.parse(config.identityAppConfig);
        //getting desired environment
        const defaultConfig = getDefaultConfig(config.shellConfig.environment)?.default;
        //storing configuration in variables
        this.shellConfig = config.shellConfig || defaultConfig.shellConfig;
        this.identityAppConfig = config.identityAppConfig || defaultConfig.identityAppConfig;
        //setting keepAlive configuration
        this.keepAlive = config.shellConfig.keepAlive || defaultConfig.shellConfig.keepAlive;

        this.tag = config.tag;
        this.appType = config.appType ? config.appType : constants.APP_TYPE_VERSION_1;
        this.iovationLib = config.iovationLib;
        this.bioCatchLib = config.bioCatchLib;
        this.getBrowserDataLib = config.getBrowserDataLib;
        this.fraudInteractionEndpoint = config.fraudInteractionEndpoint;
        this.manifest = config.manifest;
        this.appConfig = config.appConfig;
        this.authenticationRequired = config.authenticationRequired && config.authenticationRequired === 'true';
        this.abandonFormNotification = config.abandonFormNotification && config.abandonFormNotification === 'true';
        this.sessionTimeoutNotification = config.sessionTONotification && config.sessionTONotification === 'true';
        this.disableKeepAlive = config.disableKeepAlive && config.disableKeepAlive === 'true';
        this.sessionTimeoutNotificationMsg = config.sessionTONotificationMsg;
        this.cookieDisabledNotification = config.cookieNotification && config.cookieNotification === 'true';
        this.cookieDisabledNotificationMsg = config.cookieNotificationMsg;
        this.maintenanceMode = config.maintenanceMode && config.maintenanceMode === 'true';
        this.maintenanceModeTitle = config.maintenanceModeTitle;
        this.maintenanceModeMsg = config.maintenanceModeMsg;
        this.maintenanceModeButtonLabel = config.maintenanceModeButtonLabel;
        this.maintenanceModeButtonLink = config.maintenanceModeButtonLink;
        this.errorPageTitle = config.errorPageTitle;
        this.errorPageMsg = config.errorPageMsg;
        this.hostName = config.hostName;
        this.clearTokenInit = config.clearTokenInit && config.clearTokenInit === 'true';
        this.cf = config.cf;

        debug(this, 'config', config);
    }
}

const getDefaultConfig = (env: string): any => {
    let config: any = {};
    if (env === 'local') {
        config = <any>local;
    }
    return config;
};
